// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Map from "../Data.Map/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var foldr = /* #__PURE__ */ Data_Foldable.foldr(Data_Foldable.foldableArray);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Foldable.foldableArray);
var foldMap = /* #__PURE__ */ Data_Foldable.foldMap(Data_Foldable.foldableArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var bind1 = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var OMap = /* #__PURE__ */ (function () {
    function OMap(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    OMap.create = function (value0) {
        return function (value1) {
            return new OMap(value0, value1);
        };
    };
    return OMap;
})();
var foldableOMap = {
    foldr: function (f) {
        return function (z) {
            return function (v) {
                return foldr(function ($184) {
                    return f(Data_Tuple.snd($184));
                })(z)(v.value1);
            };
        };
    },
    foldl: function (f) {
        return function (z) {
            return function (v) {
                return foldl(function (acc) {
                    return function (x) {
                        return f(acc)(Data_Tuple.snd(x));
                    };
                })(z)(v.value1);
            };
        };
    },
    foldMap: function (dictMonoid) {
        var foldMap1 = foldMap(dictMonoid);
        return function (f) {
            return function (v) {
                return foldMap1(function ($185) {
                    return f(Data_Tuple.snd($185));
                })(v.value1);
            };
        };
    }
};
var values = function (v) {
    return map(Data_Tuple.snd)(v.value1);
};
var union = function (dictOrd) {
    var member1 = Data_Set.member(dictOrd);
    var union1 = Data_Map_Internal.union(dictOrd);
    return function (v) {
        return function (v1) {
            var aKeys = Data_Map.keys(v.value0);
            var b$prime$prime = Data_Array.filter(function (v2) {
                return !member1(v2.value0)(aKeys);
            })(v1.value1);
            return new OMap(union1(v.value0)(v1.value0), append(v.value1)(b$prime$prime));
        };
    };
};
var udecodeMap = function (dictDecode) {
    return function (dictDecode1) {
        var unsafeDecode = Unscramble.unsafeDecode(Unscramble.decodeArray1(Unscramble.decodeTuple(dictDecode1)(dictDecode)));
        return function (dictOrd) {
            var fromFoldable = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray);
            return {
                unsafeDecode: function (f) {
                    var kvs = unsafeDecode(f);
                    return new OMap(fromFoldable(kvs), kvs);
                }
            };
        };
    };
};
var toMap = function (v) {
    return v.value0;
};
var toArray = function (v) {
    return v.value1;
};
var size = function (v) {
    return Data_Array.length(v.value1);
};
var showOMap = function (dictShow) {
    var showTuple = Data_Tuple.showTuple(dictShow);
    return function (dictShow1) {
        var show = Data_Show.show(Data_Show.showArray(showTuple(dictShow1)));
        return {
            show: function (v) {
                return show(v.value1);
            }
        };
    };
};
var semigroupOMap = function (dictOrd) {
    return {
        append: union(dictOrd)
    };
};
var move = function (fromIndex) {
    return function (toIndex) {
        return function (v) {
            return map1(OMap.create(v.value0))(bind(Data_Array.index(v.value1)(fromIndex))(function (item) {
                return bind(Data_Array.deleteAt(fromIndex)(v.value1))(Data_Array.insertAt(toIndex)(item));
            }));
        };
    };
};
var lookup = function (dictOrd) {
    var lookup1 = Data_Map_Internal.lookup(dictOrd);
    return function (dictEq) {
        return function (needle) {
            return function (v) {
                return lookup1(needle)(v.value0);
            };
        };
    };
};
var member = function (dictOrd) {
    var lookup1 = lookup(dictOrd);
    return function (dictEq) {
        var lookup2 = lookup1(dictEq);
        return function (needle) {
            return function (haystack) {
                return Data_Maybe.isJust(lookup2(needle)(haystack));
            };
        };
    };
};
var keysSet = function (v) {
    return Data_Map.keys(v.value0);
};
var keys = function (v) {
    return map(Data_Tuple.fst)(v.value1);
};
var fromArray = function (dictOrd) {
    var fromFoldable = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray);
    return function (map2) {
        return new OMap(fromFoldable(map2), map2);
    };
};
var findIndex = function (dictEq) {
    var eq = Data_Eq.eq(dictEq);
    return function (needle) {
        return function (v) {
            return Data_Array.findIndex(function (v1) {
                return eq(v1.value0)(needle);
            })(v.value1);
        };
    };
};
var eqOMap = function (dictEq) {
    var eqTuple = Data_Tuple.eqTuple(dictEq);
    return function (dictEq1) {
        var eq = Data_Eq.eq(Data_Eq.eqArray(eqTuple(dictEq1)));
        return {
            eq: function (v) {
                return function (v1) {
                    return eq(v.value1)(v1.value1);
                };
            }
        };
    };
};
var encodeMap = function (dictEncode) {
    var encode = Foreign_Generic_Class.encode(Foreign_Generic_Class.arrayEncode(dictEncode));
    return {
        encode: function (v) {
            return encode(map(function (v1) {
                return new Data_Tuple_T2.T2(v1.value0, v1.value1);
            })(v.value1));
        }
    };
};
var empty = /* #__PURE__ */ (function () {
    return new OMap(Data_Map_Internal.empty, [  ]);
})();
var monoidOMap = function (dictOrd) {
    var semigroupOMap1 = semigroupOMap(dictOrd);
    return {
        mempty: empty,
        Semigroup0: function () {
            return semigroupOMap1;
        }
    };
};
var $$delete = function (dictOrd) {
    var delete1 = Data_Map_Internal["delete"](dictOrd);
    var notEq = Data_Eq.notEq(dictOrd.Eq0());
    return function (key) {
        return function (v) {
            return new OMap(delete1(key)(v.value0), Data_Array.filter(function (v1) {
                return notEq(v1.value0)(key);
            })(v.value1));
        };
    };
};
var insert = function (dictOrd) {
    var delete1 = $$delete(dictOrd);
    var insert1 = Data_Map_Internal.insert(dictOrd);
    return function (k) {
        return function (v) {
            return function (m0) {
                var v1 = delete1(k)(m0);
                return new OMap(insert1(k)(v)(v1.value0), Data_Array.snoc(v1.value1)(new Data_Tuple.Tuple(k, v)));
            };
        };
    };
};
var decodeMap = function (dictDecode) {
    var decode = Foreign_Generic_Class.decode(Foreign_Generic_Class.arrayDecode(dictDecode));
    return function (dictOrd) {
        var fromFoldable = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray);
        return {
            decode: function (f) {
                return bind1(decode(f))(function (v) {
                    var kvs$prime = map(function (v1) {
                        return new Data_Tuple.Tuple(v1.value0, v1.value1);
                    })(v);
                    return pure(new OMap(fromFoldable(kvs$prime), kvs$prime));
                });
            }
        };
    };
};
export {
    lookup,
    member,
    toArray,
    toMap,
    fromArray,
    empty,
    keys,
    keysSet,
    values,
    findIndex,
    move,
    $$delete as delete,
    insert,
    size,
    showOMap,
    eqOMap,
    semigroupOMap,
    monoidOMap,
    encodeMap,
    decodeMap,
    udecodeMap,
    foldableOMap
};
